import React, { useEffect, useState } from "react";
import { useForm } from "../../../components/forms/Form";
import styles from "./authentication.module.css";
import { useAppContext } from "../../../components/activity/AppContext";
import AuthenticationActions from './authentication.actions';
import DeleteIcon from "../../../images/delete.png";
import { generateUuid } from "../../../common";
import UserManagementActions from "../userManagement/userManagement.actions";
import { fileUploadData } from "../../../../actions/admin";
import PopUp from "../../../components/layouts/PopUp";

export default function UserMapping(props) {

    const { authData, fetchAuthenticationData, currentAuthData , handleClose , renderComponent , isEdit , fields , setFields , systemFields , setSystemFields , setPopUp } = props;
    const [systemList, setSystemList] = useState();

  
    
    const app = useAppContext();
    
    const onWatch = (errors, value) => {
        errors.clearAll()
        fields[value.name] = value.value;
    };

    const closeAllPopups = ()=>{
            handleClose()
            setPopUp()
          
    }

    const onSubmit = async (values, errors) => {
        const mapping = {}
        for (const key of Object.keys(values)) {
            if (key.startsWith("key_")) {
                const id = key.split("_")[1];
                const valueKey = `value_${id}`;      
                if (values[key] && !values[valueKey]) {
                    errors.set(valueKey, "Please enter the user property value.");
                    return;
                } else if(values[key]) {
                    mapping[values[key]] = values[valueKey];
                }
            }
        }

        let updateData = {name:authData.name ,  description:authData.description , authName: authData.authName, config : authData.config, entityId: authData.entityId , mapping : mapping , isActive:authData.isActive  };
    
        const actions = AuthenticationActions(app());
        // const update = actions.validateAuthChanges({...authData,...updateData}, currentAuthData , "submit" , "Saml");
        if (isEdit) {
            const [error,data] = await actions.updateAuthentication({...updateData,id:authData?.id});
            if(!error){
              closeAllPopups()
            }
        }
        else{
            const [error,data] = await actions.createAuthentication(updateData);
            if(!error){
              closeAllPopups()
            }
        }
        fetchAuthenticationData();

    };



    const handleDelete = (index) => {
        let list = [...systemFields];
        list = list.filter(e => e !== index);
        const keysToRemove = [`key_${index}`, `value_${index}`];
        const filteredData = Object.keys(fields).reduce((acc, key) => {
            if (!keysToRemove.includes(key)) {
                acc[key] = fields[key];
            }
            return acc;
        }, {});
        setFields(filteredData)
        setSystemFields(list);

    }

    const handleAdd = () => {
        let uuid = generateUuid()
        const list = [...systemFields];
        list.push(uuid)
        setSystemFields(list)
    }

    const { Form, Select, Input, Label, Error } = useForm(fields, onSubmit, onWatch);

      const getUserPropertyList = async (filter) => {
          const actions = UserManagementActions(app());
          const [, data] = await actions.getPropertiesList(filter);
          setSystemList(data?.data);
      }
  
    useEffect(()=>{
        getUserPropertyList()
        if(authData && authData?.mapping){
            const ids = []
            const fields = {}
            const mapping = authData?.mapping
            Object.entries(mapping).forEach(([key, value]) => {
                   const id = generateUuid()
                   ids.push(id)
                   fields[`key_${id}`] = key
                   fields[`value_${id}`] = value
              });
            setSystemFields(ids)
            setFields(fields)
        }
    },[])


    const handleBack = ()=>{
        handleClose()
    
    }



   
    return (
              <PopUp popUp={renderComponent} setPopUp={handleClose} title={authData.authName}>
                <Form>
                    <div >
                        <h2 data-header-testid="User Mappings" className={styles.rolesLyoutTitle}>Attribute Mappings</h2>
                            <>
                                <div className='selectInputFieldsContainer'>
                                    {/* <button className="userm-button" data-clickable-testid="new-system" onClick={handleAdd}> + New System </button> */}
                                    <div> {systemFields?.map((uuid, index) => {
                                        return (
                                            // <System  item={fields[uuid]} index={uuid} systemList={systemList} handleDelete = {handleDelete} handleUpdate={handleUpdate} uuid={uuid}/>

                                            <div className='form-field-varied'>
                                    
                                                <div className='form-select-varied-hide'>
                                                    <Input
                                                        style={{height:"40px"}}
                                                        className='input-align'
                                                        placeholder="Attribute Name"
                                                        name={"key_" + uuid}
                                                        id="value"
                                                        data-input-testid="system-input"
                                                        value={fields["key_" + uuid]}
                                                    />
                                                    <Error name={"key_" + uuid} />
                                                </div>
                                                <div>
                                                    <Select
                                                        placeholder='Select'
                                                        // value={fields[`value_${uuid}`]}
                                                        data-option-testid="system-select"
                                                        id="userProperty"
                                                        name={"value_" + uuid}
                                                        value={fields[`value_${uuid}`]}
                                                        >
                                                        <option value=''>User property</option>
                                                        {systemList?.map((system, index) => {
                                                            return (
                                                                <option
                                                                    key={index}
                                                                    value={system.propertyUuid}
                                                        
                                                                    id={system.propertyUuid}
                                                                >
                                                                    {system.name}
                                                                </option>
                                                            )
                                                        })}
                                                    </Select>
                                                    <Error name={"value_" + uuid} />
                                                </div>
                                                
                                                <div style={{ height: "100%", cursor: "pointer", paddingBottom: "16px" }}>
                                                    <img
                                                        data-clickable-testid="system-delete"
                                                        src={DeleteIcon}
                                                        alt="Delete System"
                                                        onClick={() => handleDelete(uuid)} />
                                                </div>
                                                
                                            </div>


                                        )
                                    })}
                                    </div>
                                    <Input data-clickable-testid="new-system" type="button" className="secondary" value={"+ Add"} onClick={handleAdd} style={{marginBottom:"5px"}} />
                                </div>
                            </>

                            <div className={styles.submitContainer}>
                                 <input data-clickable-testid="back" className='secondary' type="submit" value="Back" onClick={handleBack}/>
                                <input data-clickable-testid="update" className={"primary"} type="submit" value="Save" />
                     
                             </div>
                        
                    </div>
                </Form>
                
              </PopUp>
    );
}